/** `gallerySettingsFromMonday()` — `specs/M4-V7-gallery.md` §4, over all four production rows. */
import { columnSelectionFromMonday, singleColumnFromMonday } from '../column-selection.js';
import { extraKeys, parseViewSettingsBlob, presentKeys } from '../from-monday.js';
import { DEFAULT_GALLERY_VIEW_SETTINGS, GALLERY_MONDAY_KEYS, } from './index.js';
export function gallerySettingsFromMonday(raw) {
    const { object, warnings } = parseViewSettingsBlob(raw, 'gallery');
    return {
        settings: {
            coverColumnId: singleColumnFromMonday(object['cover_column']),
            cardColumns: Object.hasOwn(object, 'card_columns')
                ? columnSelectionFromMonday(object['card_columns'])
                : DEFAULT_GALLERY_VIEW_SETTINGS.cardColumns,
            cardSize: DEFAULT_GALLERY_VIEW_SETTINGS.cardSize,
            mondayKeys: presentKeys(object, GALLERY_MONDAY_KEYS),
            mondayExtras: extraKeys(object, GALLERY_MONDAY_KEYS),
        },
        warnings,
    };
}
//# sourceMappingURL=from-monday.js.map